/**
 * mySubordinatesApi.js
 * --------------------
 * API client for My Subordinates module.
 * Connects directly to FastAPI endpoint /self-service/subordinates/ adhering to Rule 90.
 */
import api from '../../../../api/client';

export const SUBORDINATE_DEPT_OPTIONS = [
  { value: 'All', label: 'All Departments' },
  { value: 'Product Development', label: 'Product Development' },
  { value: 'UI/UX & Design', label: 'UI/UX & Design' },
  { value: 'Backend Engineering', label: 'Backend Engineering' },
  { value: 'Data & Analytics', label: 'Data & Analytics' },
  { value: 'Engineering & DevOps', label: 'Engineering & DevOps' },
  { value: 'QA & Compliance', label: 'QA & Compliance' },
  { value: 'Operations & Facilities', label: 'Operations & Facilities' },
  { value: 'Human Resources', label: 'Human Resources' },
  { value: 'Finance & Accounts', label: 'Finance & Accounts' },
];

export const mySubordinatesApi = {
  getList: async () => {
    try {
      const response = await api.get('/self-service/subordinates/');
      return { data: response.data.data || [] };
    } catch (err) {
      console.warn('Failed to fetch subordinates from server:', err);
      return { data: [] };
    }
  },
};
